/** @format */

import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      {/* Footer Start */}
      <div
        className="container-fluid bg-dark text-body footer mt-5 pt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-3 col-md-6">
              <h5 className="text-white mb-4">Address</h5>
              <p className="mb-2">
                <i className="fa fa-map-marker-alt me-3" />
                UK
              </p>
              <p className="mb-2">
                <i className="fa fa-phone-alt me-3" />
                +09090102030
              </p>
              <p className="mb-2">
                <i className="fa fa-envelope me-3" />
                abcd@gmail.com
              </p>
              <div className="d-flex pt-2">
                <a className="btn btn-square btn-outline-light btn-social" href>
                  <i className="fab fa-twitter" />
                </a>
                <a className="btn btn-square btn-outline-light btn-social" href>
                  <i className="fab fa-facebook-f" />
                </a>
                <a className="btn btn-square btn-outline-light btn-social" href>
                  <i className="fab fa-youtube" />
                </a>
                <a className="btn btn-square btn-outline-light btn-social" href>
                  <i className="fab fa-linkedin-in" />
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h5 className="text-white mb-4">Quick Links</h5>
              <Link to="/About" className="btn btn-link">
                About Us
              </Link>
              {/* <a className="btn btn-link" href>
                About Us
              </a> */}
              {/* <a className="btn btn-link" href>
                Contact Us
              </a> */}
              <Link to="/Contact" className="btn btn-link">
                Contact Us
              </Link>
              <Link to="/Service" className="btn btn-link">
                Our Services
              </Link>
              {/* <a className="btn btn-link" href>
                Our Services
              </a> */}

              <a className="btn btn-link" href>
                Terms &amp; Condition
              </a>
              <Link to="/Features" className="btn btn-link">
                Support
              </Link>
              {/* <a className="btn btn-link" href>
                Support
              </a> */}
            </div>
            <div className="col-lg-3 col-md-6">
              <h5 className="text-white mb-4">Project Gallery</h5>
              <div className="row g-2">
                <div className="col-4">
                  <img
                    className="img-fluid rounded"
                    src="img/gallery-1.jpg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid rounded"
                    src="img/gallery-2.jpg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid rounded"
                    src="img/gallery-3.jpg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid rounded"
                    src="img/gallery-4.jpg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid rounded"
                    src="img/gallery-5.jpg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid rounded"
                    src="img/gallery-6.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h5 className="text-white mb-4">Newsletter</h5>
              <p>
                Renewable energy project newsletter: Learn about the project's
                progress, successes, and upcoming events. Subscribe today!
              </p>
              <div
                className="position-relative mx-auto"
                style={{ maxWidth: "400px" }}
              >
                <input
                  className="form-control border-0 w-100 py-3 ps-4 pe-5"
                  type="text"
                  placeholder="Your email"
                />
                <button
                  type="button"
                  className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
                >
                  SignUp
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                © <a href="#">Eco Solutions</a>, All Right Reserved.
              </div>
              <div className="col-md-6 text-center text-md-end"></div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}
    </>
  );
}

export default Footer;
